import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CityService } from '@city/feature';
import { environment, HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { AnyQuerySuggestions, CustomSearchResults, VENDOR_ENDPOINTS } from '@search/const';
import { SUGGESTIONS_ANY_QUERY_NORMALIZER } from '@search/utils';
import { ConverterService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OccSearchSuggestionsAnyQueryService {
  constructor(
    private http: HttpClient,
    private converter: ConverterService,
    private cityService: CityService,
  ) {}

  loadCustomSuggestions(term: string): Observable<CustomSearchResults> {
    return this.cityService.activeBaseStoreCode$.pipe(
      switchMap((baseStoreCode) =>
        this.http
          .get<AnyQuerySuggestions>(VENDOR_ENDPOINTS.suggestions, {
            context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, 'autocomplete.diginetica.net/autocomplete'),
            params: new HttpParams({
              fromObject: {
                st: term,
                apiKey: environment.anyQueryApiKey,
                regionId: baseStoreCode,
                productsSize: '10',
                forIs: true,
                strategy: 'vectors_extended,zero_queries',
                showUnavailable: false,
                withContent: false,
                withSku: false,
              },
            }),
          })
          .pipe(this.converter.pipeable(SUGGESTIONS_ANY_QUERY_NORMALIZER)),
      ),
    );
  }
}
